import React, { memo, useEffect, useState } from "react";
import {
  TabContext,
  TabList,
  Box,
  Tab,
  TabPanel,
  Alert,
  Stack,
  Switch,
  FormControlLabel,
  Typography,
} from "investira.react.components";
import { validators, arrays } from "investira.sdk";
import Segmentos from "./Segmentos";
import Emissor from "./Emissor";
import Entidade from "./Entidade";
import Limite from "./Limite";
import { useConsultaContext } from "../../../../contexts/ConsultaContext";

const Secoes = memo((props) => {
  const { data } = props;

  const { state, actions } = useConsultaContext();

  const [value, setValue] = useState(null);
  const [secoes, setSecoes] = useState({});
  const [secoesDetalhes, setSecoesDetalhes] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function groupSecoesSegmemtos(pData) {
    if (validators.isNull(pData)) {
      return {};
    }
    // Objeto para armazenar seções únicas com seus segmentos
    const xSecoesUnicas = {};

    // Iterar sobre cada item no array pData
    pData.forEach((xItem) => {
      const xSecao = xItem.secao;
      const xErro = xItem.erro;
      const xSegmento = xItem.segmento;

      if (xErro) {
        console.log(xItem);
      }

      // Se a seção ainda não foi registrada, adicioná-la ao objeto
      if (!xSecoesUnicas[xSecao.id]) {
        xSecoesUnicas[xSecao.id] = {
          secao: {
            ...xSecao,
          },
          erro: xErro,
          segmentos: {},
        };
      }

      // Adicionar o segmento único à seção correspondente
      // Se 'segmento' não existir ou for inválido, ignora
      if (!xSegmento || typeof xSegmento !== "object" || !xSegmento.id) {
        return;
      } else {
        // Adiciona o segmento válido
        if (!xSecoesUnicas[xSecao.id].segmentos[xSegmento.id]) {
          xSecoesUnicas[xSecao.id].segmentos[xSegmento.id] = {
            id: xSegmento.id,
            descricao: xSegmento.descricao || "", // Trata caso 'descricao' não exista
          };
        }
      }
    });

    // Converter o objeto em um array formatado
    const resultado = Object.values(xSecoesUnicas).map((xItem) => ({
      id: xItem.secao.id,
      secao: xItem.secao,
      erro: xItem.erro,
      segmentos: Object.values(xItem.segmentos),
    }));

    return resultado;
  }

  function agruparDetalhesPorSecaoId(pData) {
    // Verifica se o input é válido
    if (!Array.isArray(pData)) {
      console.error("O parâmetro deve ser um array.");
      return {};
    }

    const xResultado = {};

    pData.forEach((item) => {
      // Verifica se o item tem seção válida
      if (!item.secao || !item.secao.id) {
        console.warn("Item sem seção válida:", item);
        return;
      }

      const xSecaoId = item.secao.id;

      // Verifica se o item tem detalhes válidos
      if (!item.detalhe || !Array.isArray(item.detalhe)) {
        console.warn("Item sem detalhes válidos:", item);
        return;
      }

      // Cria a entrada para a seção se não existir
      if (!xResultado[xSecaoId]) {
        xResultado[xSecaoId] = {
          secao: {
            id: item.secao.id,
            apelido: item.secao.apelido || "",
            descricao: item.secao.descricao || "",
          },
          detalhe: [],
        };
      }

      // Adiciona os detalhes à seção correspondente
      xResultado[xSecaoId].detalhe.push(item);
    });

    console.log("xResultado", xResultado);

    return xResultado;
  }

  useEffect(() => {
    if (!validators.isNull(data.response?.detalhe)) {
      const xDetalhe = data.response.detalhe;

      if (state.orderBy) {
        xDetalhe.forEach((item) => {
          item.detalhe.sort((a, b) => {
            const isinA = a.isin || a.cnpj || "";
            const isinB = b.isin || b.cnpj || "";
            return isinA.localeCompare(isinB);
          });
        });
      }

      setSecoes(arrays.arrayToObject(groupSecoesSegmemtos(xDetalhe), "id"));
      setSecoesDetalhes(agruparDetalhesPorSecaoId(xDetalhe));
      setValue(xDetalhe[0].secao.id);
    }
  }, [data.response, state.orderBy]);

  if (validators.isNull(data.response) || validators.isNull(value)) {
    return null;
  }

  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="Seções"
        >
          {Object.entries(secoes).map(([xKey, xValue]) => {
            return (
              <Tab
                key={`tab-${xKey}`}
                label={xValue.secao.apelido}
                value={xKey}
              />
            );
          })}
        </TabList>
      </Box>
      <Stack direction="row" justifyContent="flex-end">
        <FormControlLabel
          control={
            <Switch
              checked={state.orderBy}
              onChange={(e) => actions.handleUpdateOrderBy(e.target.checked)}
              inputProps={{ "aria-label": "primary checkbox" }}
              size="small"
            />
          }
          label={
            <Typography color="textSecondary" variant="caption">
              Ordernar por ISIN/CNPJ
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Switch
              checked={state.exibir_desenquadrado}
              onChange={(e) =>
                actions.handleUpdateExibirDesenquadrado(e.target.checked)
              }
              inputProps={{ "aria-label": "primary checkbox" }}
              size="small"
            />
          }
          label={
            <Typography color="textSecondary" variant="caption">
              Mostrar apenas desenquadrado
            </Typography>
          }
        />
      </Stack>

      <TabPanel value={"SEG"} sx={{ px: 0, marginTop: "0px !important" }}>
        <Limite
          segmentos={secoes[value].segmentos}
          detalhe={secoesDetalhes[value].detalhe}
          variant={value}
        />
      </TabPanel>

      <TabPanel
        value={"EMI"}
        sx={{ px: 0, py: 0, marginTop: "0px !important" }}
      >
        <Emissor
          segmentos={secoes[value].segmentos}
          detalhe={secoesDetalhes[value].detalhe}
          variant={value}
        />
      </TabPanel>
      <TabPanel
        value={"CON"}
        sx={{ px: 0, py: 0, marginTop: "0px !important" }}
      >
        <Entidade
          segmentos={secoes[value].segmentos}
          detalhe={secoesDetalhes[value].detalhe}
          variant={value}
        />
      </TabPanel>
      <TabPanel
        value={"VED"}
        sx={{ px: 0, py: 0, marginTop: "0px !important" }}
      >
        <Entidade
          segmentos={secoes[value].segmentos}
          detalhe={secoesDetalhes[value].detalhe}
          variant={value}
        />
      </TabPanel>
      <TabPanel
        value={"OUT"}
        sx={{ px: 0, py: 0, marginTop: "0px !important" }}
      >
        <Entidade
          segmentos={secoes[value].segmentos}
          detalhe={secoesDetalhes[value].detalhe}
          variant={value}
        />
      </TabPanel>
    </TabContext>
  );
});

export default Secoes;
